<template>
  <div>
    <ClientOnly>
      <component
        :is="iconComponent"
        :class="[twMerge('aspect-square', attrs.class)]"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
/** packages */
import { defineAsyncComponent } from 'vue'
import { useNuxtApp } from 'nuxt/app'
import { twMerge } from 'tailwind-merge'

/** types */
import type { TRecord } from '~/src/types/common'

/** props */
const props = defineProps<{ name: string }>()

/** app */
const { $assets } = useNuxtApp()
const attrs = useAttrs() as TRecord

/** components */
const iconComponent = defineAsyncComponent(async () => {
  const icon = $assets.getIconByName(props.name)
  if (!icon) throw new Error(`Icon ${props.name} not found`)
  return icon()
})
</script>
